import React from "react";
import { Box, Typography } from "@mui/material";
import TitleHeaders from "../../../Components/CluppForms/TitleHeaders";
import odometer from "../../../Assets/ExplanationOdemeter.png";

const OdometerPhotoExplanation = () => {
  return (
    <Box>
      <TitleHeaders
        title={"¿Debo subir una foto de mi odómetro cada mes? 📸"}
        subtitle={
          <>
            <Typography variant="h6" color="#000" sx={{ fontWeight: 600 }}>
              ¡NO😉!
            </Typography>
            <Typography variant="subtitle1">
              Solo necesitas subir la foto de tu odómetro durante los primeros
              tres meses. Después de eso, nuestra app te avisará cuando sea
              necesario hacerlo nuevamente.
            </Typography>
            <Typography variant="subtitle1" sx={{ marginTop: "10px" }}>
              Así es como se verá la solicitud en tu app:
            </Typography>
          </>
        }
        isRequired={false}
      />
      <Box sx={{textAlign: "center"}}>
      <img
        src={odometer}
        alt="Odometer Explanation"
        style={{ maxWidth: "280px", border: "1px solid #cecece", borderRadius: "20px"  }}
      />
      </Box>

    </Box>
  );
};

export default OdometerPhotoExplanation;
